import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { bendConfig } from "./data";

export default function BendPage() {
  return <OregonCityPageTemplate config={bendConfig} />;
}